module.exports = __webpack_public_path__ + "static/media/okbIcon.3f1f07b6.webp";